(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rasca-gana"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.getElementById('RascaGana');
    var fab = document.getElementById('RascaGanaFab');
    if (!root || !fab) return;

    var code = root.dataset.code;
    var snoozeMs = parseFloat(root.dataset.snoozeDays) * 86400000;
    var designMode = root.dataset.designMode === 'true';
    var KEY_DONE = 'rg_done';
    var KEY_CLOSED = 'rg_closed_at';

    function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }

    var done = store(KEY_DONE) === '1';
    var closedAt = parseInt(store(KEY_CLOSED) || '0', 10);
    var snoozed = closedAt && Date.now() - closedAt < snoozeMs;
    var opened = false;
    var canvasReady = false;

    function show(step) {
      root.querySelectorAll('[data-rg-step]').forEach(function (el) { el.hidden = el.dataset.rgStep !== step; });
    }

    function open() {
      if (opened) return;
      opened = true;
      root.hidden = false;
      fab.hidden = true;
      if (done) { show('done'); return; }
      if (!canvasReady) { show('scratch'); requestAnimationFrame(initCanvas); }
    }

    function close() {
      root.hidden = true;
      opened = false;
      store(KEY_CLOSED, String(Date.now()));
      fab.hidden = false;
    }

    root.querySelectorAll('[data-rg-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && opened) close(); });
    fab.addEventListener('click', open);

    function initCanvas() {
      var canvas = root.querySelector('.rg__canvas');
      var rect = canvas.getBoundingClientRect();
      var ratio = window.devicePixelRatio || 1;
      canvas.width = rect.width * ratio;
      canvas.height = rect.height * ratio;
      var ctx = canvas.getContext('2d');
      ctx.scale(ratio, ratio);

      var grad = ctx.createLinearGradient(0, 0, rect.width, rect.height);
      grad.addColorStop(0, '#c9a465');
      grad.addColorStop(0.5, '#b08a49');
      grad.addColorStop(1, '#8f6d33');
      ctx.fillStyle = grad;
      ctx.fillRect(0, 0, rect.width, rect.height);
      ctx.fillStyle = 'rgba(255,255,255,0.12)';
      for (var i = 0; i < 40; i++) {
        ctx.beginPath();
        ctx.arc(Math.random() * rect.width, Math.random() * rect.height, Math.random() * 2 + 0.5, 0, Math.PI * 2);
        ctx.fill();
      }
      ctx.fillStyle = '#ffffff';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.font = '700 22px Montserrat, sans-serif';
      ctx.fillText('RASCA AQUÍ ✨', rect.width / 2, rect.height / 2);

      ctx.globalCompositeOperation = 'destination-out';
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.lineWidth = 38;

      var drawing = false;
      var last = null;
      var moves = 0;
      var revealed = false;

      function pos(e) {
        var r = canvas.getBoundingClientRect();
        return { x: e.clientX - r.left, y: e.clientY - r.top };
      }

      function scratch(p) {
        ctx.beginPath();
        if (last) { ctx.moveTo(last.x, last.y); ctx.lineTo(p.x, p.y); ctx.stroke(); }
        else { ctx.arc(p.x, p.y, 19, 0, Math.PI * 2); ctx.fill(); }
        last = p;
        if (++moves % 8 === 0) check();
      }

      function check() {
        if (revealed) return;
        var data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
        var clear = 0, total = 0;
        for (var j = 3; j < data.length; j += 64) { total++; if (data[j] === 0) clear++; }
        if (clear / total > 0.45) reveal();
      }

      function reveal() {
        revealed = true;
        canvas.classList.add('is-cleared');
        setTimeout(function () { show('form'); var input = root.querySelector('input[name="email"]'); if (input) input.focus(); }, 900);
      }

      canvas.addEventListener('pointerdown', function (e) { drawing = true; last = null; canvas.setPointerCapture(e.pointerId); scratch(pos(e)); });
      canvas.addEventListener('pointermove', function (e) { if (drawing) scratch(pos(e)); });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (t) {
        canvas.addEventListener(t, function () { drawing = false; last = null; check(); });
      });
      canvasReady = true;
    }

    var form = root.querySelector('.rg__form');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = form.email.value.trim();
      var phone = form.phone.value.replace(/[^\d+]/g, '');
      var error = form.querySelector('.rg__error');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { error.hidden = false; return; }
      error.hidden = true;

      var btn = form.querySelector('button[type="submit"]');
      btn.disabled = true;

      var tags = ['rasca-y-gana', 'popup-regalo10'];
      if (phone) tags.push('whatsapp-' + phone.replace('+', ''));

      var body = new URLSearchParams();
      body.append('form_type', 'customer');
      body.append('utf8', '✓');
      body.append('contact[email]', email);
      body.append('contact[tags]', tags.join(','));
      body.append('contact[accepts_marketing]', 'true');

      var finish = function () {
        store(KEY_DONE, '1');
        done = true;
        show('done');
      };

      Promise.allSettled([
        fetch('/contact#contact_form', { method: 'POST', body: body, headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }),
        fetch('/discount/' + encodeURIComponent(code))
      ]).then(finish);
    });

    var copyBtn = root.querySelector('[data-rg-copy]');
    copyBtn.addEventListener('click', function () {
      var label = root.querySelector('[data-rg-copy-label]');
      var ok = function () { label.textContent = '¡Copiado!'; setTimeout(function () { label.textContent = 'Copiar código'; }, 2000); };
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(ok, ok); else ok();
    });

    if (designMode) return;
    if (done) return;
    if (snoozed) { fab.hidden = false; return; }

    var timer = setTimeout(open, parseInt(root.dataset.delay, 10));
    var threshold = parseFloat(root.dataset.scroll);
    function onScroll() {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      if (max > 0 && window.scrollY / max >= threshold) { window.removeEventListener('scroll', onScroll); clearTimeout(timer); open(); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      document.addEventListener('mouseout', function onExit(e) {
        if (!e.relatedTarget && e.clientY <= 0) { document.removeEventListener('mouseout', onExit); clearTimeout(timer); open(); }
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
